import React, {Component} from 'react'
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Button, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ColumnGroup} from 'primereact/columngroup';
import dialog from "../../../../../components/dialog/Dialog";
import ClaimObservationsModal from "./observation/ClaimObservationsModal";
import RemotingService from "../../../../../services/remoting-service/RemotingService";
import {XmlPreviewModal} from "../../../../../components";
import moment from "moment";
import NotificationService from "../../../../../services/notification-service/NotificationService";
import VersionModal from "../../component/VersionModal";
import ResubmissionsModal from "../resubmission/ResubmissionsModalV2";
import ClaimCheckerResultDialog from "./ClaimCheckerResultDialog";
import EclaimTransactionLogModal from "./EclaimTransactionLogModal";

// Submission stays visible but disabled on production until the go-live decision
const CLAIM_SUBMISSION_DISABLED = process.env.REACT_APP_MY_ENV === "production";

export default class ClaimActivities extends Component {

    constructor(props) {
        super(props);
        this.dataTableRef = React.createRef();
        this.state = {
            items: [],
            selectedItems: [],
            xmlPreviewModalVisible: false,
            previewXml: '',
            editedXml: '',
            submitting: false,
            checking: false,
            claimCheckResult: null,
            claimCheckDialogVisible: false
        };
    }

    openObservationDialog(claimActivityId) {
        dialog({
            title: "Observations",
            component: <ClaimObservationsModal claimActivityId={claimActivityId} claimId={this.props.claim.id}/>
        });
    }

    observationTemplate(claimActivity) {
        return (
            <div onClick={() => this.openObservationDialog(claimActivity.id)}>
                <span className="text-break cursor-pointer mr-1"><u>Observations</u></span><FontAwesomeIcon icon="paperclip"/>
            </div>
        )
    }

    onStatusFilterChange = (event) => {
        this.dataTableRef.current.filter(event.value, 'status', 'equals');
        this.setState({selectedStatusFilter: event.value  });
    }

    showSubmissionResult = (result) => {
        if (result.success) {
            NotificationService.showNotification({severity: 'success', summary: 'Success', detail: result.message});
            this.props.onClaimSubmitted(); // a blocked or failed submission changes nothing worth the slow reload
        } else if (result.audits && result.audits.length > 0) {
            // Blocked by the internal audit: show the failed checks instead of a toast
            this.setState({claimCheckResult: result, claimCheckDialogVisible: true, claimCheckDialogHeader: 'Claim Submission'});
        } else {
            NotificationService.showNotification({
                severity: 'error',
                summary: 'Submission Failed',
                detail: result.message + (result.errorReport ? `\n${result.errorReport}` : '')
            });
        }
    }

    submitClaim = () => {
        const selectedActivityIds = this.state.selectedItems.map(activity => activity.id);
        this.setState({submitting: true});
        RemotingService.postRemoteCall(`api/insurance/coordinator/v2/claims/claim/${this.props.claim.id}/eclaim-submission`,
            {activityIds: selectedActivityIds, editedXml: null},
            (result) => {
                this.setState({submitting: false});
                this.showSubmissionResult(result);
            }, () => {
                this.setState({submitting: false});
            });
    }

    checkClaim = () => {
        const selectedActivityIds = this.state.selectedItems.map(activity => activity.id);
        this.setState({checking: true});
        RemotingService.postRemoteCall(`api/insurance/coordinator/v2/claims/claim/${this.props.claim.id}/claim-check`,
            {activityIds: selectedActivityIds, editedXml: null},
            (result) => {
                this.setState({checking: false, claimCheckResult: result, claimCheckDialogVisible: true, claimCheckDialogHeader: 'Claim Check'});
            }, () => {
                this.setState({checking: false});
            });
    }

    generateXmlPreview = () => {
        const selectedActivityIds = this.state.selectedItems.map(activity => activity.id);
        RemotingService.postRemoteCall(
            `api/insurance/coordinator/v2/claims/claim/${this.props.claim.id}/xml-preview`,
            selectedActivityIds,
            (result) => {
                this.setState({
                    xmlPreviewModalVisible: true,
                    previewXml: result.xmlContent,
                    editedXml: result.xmlContent
                });
            }, () => {});
    }

    submitToEClaim = () => {
        const selectedActivityIds = this.state.selectedItems.map(activity => activity.id);
        const submitDTO = {
            activityIds: selectedActivityIds,
            editedXml: this.state.editedXml !== this.state.previewXml ? this.state.editedXml : null
        };

        this.setState({submitting: true});
        RemotingService.postRemoteCall(
            `api/insurance/coordinator/v2/claims/claim/${this.props.claim.id}/eclaim-submission`,
            submitDTO,
            (result) => {
                this.setState({
                    xmlPreviewModalVisible: false,
                    submitting: false,
                    previewXml: '',
                    editedXml: '',
                    selectedItems: []
                });
                this.showSubmissionResult(result);
            },
            () => {
                this.setState({submitting: false});
            }
        );
    }

    renderXmlPreviewModal = () => {
        const ts = moment().format("YYYYMMDD_HHmmss");
        return (
            <XmlPreviewModal
                visible={this.state.xmlPreviewModalVisible}
                header="Claim XML Preview"
                xml={this.state.editedXml}
                onXmlChange={(value) => this.setState({editedXml: value})}
                downloadFilename={`ClaimSubmission_${ts}.xml`}
                onSubmit={() => this.submitToEClaim()}
                submitting={this.state.submitting}
                submitDisabled={CLAIM_SUBMISSION_DISABLED}
                onClose={() => this.setState({xmlPreviewModalVisible: false, previewXml: '', editedXml: ''})}
            />
        );
    }

    renderHeaders = () =>{
        return <ColumnGroup>
            <Row>
                <Column selectionMode="multiple" headerStyle={{width: '3em'}} />
                <Column header="Activity ID" colSpan={1}/>
                <Column header="Start" colSpan={1}/>
                <Column header="Type" colSpan={1}/>
                <Column header="Code" colSpan={1}/>
                <Column header="Quantity" colSpan={1}/>
                <Column header="Gross" colSpan={1}/>
                <Column header="Patient Share" colSpan={1}/>
                <Column header="Net" colSpan={1}/>
                <Column header="Ordering Clinician" colSpan={1}/>
                <Column header="Performing Clinician" colSpan={1}/>
                <Column header="Observation" colSpan={1}/>
                <Column header="Resubmission" colSpan={1}/>
                <Column header="Submission Version" colspan={1}/>
                <Column header="Remittance Version" colspan={1}/>
            </Row>
        </ColumnGroup>;
    }

    openVersionModal(versions) {
        dialog({
            title: "Versions",
            component: <VersionModal versions={versions}/>
        });
    }

    // Submission versions are the claim's eClaim transaction log: every sent XML with its version number
    openSubmissionVersionModal() {
        dialog({
            title: "Submission Versions",
            component: <EclaimTransactionLogModal claimId={this.props.claim.id}/>
        });
    }

    submissionVersionTemplate() {
        return (
            <div onClick={() => this.openSubmissionVersionModal()}>
                <span className="text-break cursor-pointer mr-1"><u>Versions</u></span><FontAwesomeIcon icon="paperclip"/>
            </div>
        )
    }

    remittanceVersionTemplate(claimActivity) {
        return (
            <div onClick={() => this.openVersionModal(claimActivity.remittanceVersionList)}>
                <span className="text-break cursor-pointer mr-1"><u>Versions</u></span><FontAwesomeIcon icon="paperclip"/>
            </div>
        )
    }

    resubmisssionTemplate(claimActivity) {
        return (
            <div onClick={() => this.openResubmissionDialog(claimActivity.id)}>
                <span className="text-break cursor-pointer mr-1"><u>Resubmissions</u></span>
            </div>
        )
    }

    openResubmissionDialog(claimActivityId) {
        dialog({
            title: "Resubmissions",
            component: <ResubmissionsModal claimActivityId={claimActivityId}/>
        });
    }

    render() {

        return (
            <>
                <div className="float-left" style={{display: "flex", gap: "10px"}}>
                    <Button disabled={this.state.selectedItems.length === 0 || this.state.checking}
                            variant="warning"
                            onClick={() => this.checkClaim()}>
                        <FontAwesomeIcon icon="check-double"/> {this.state.checking ? 'Checking...' : 'Claim Check'}
                    </Button>
                    <Button disabled={this.state.selectedItems.length === 0}
                            variant="success"
                            onClick={() => this.generateXmlPreview()}>
                        Preview XML
                    </Button>
                    <Button disabled={CLAIM_SUBMISSION_DISABLED || this.state.selectedItems.length === 0 || this.state.submitting}
                            variant="success"
                            onClick={() => this.submitClaim()}>
                        {this.state.submitting ? 'Submitting...' : 'Submit Claim'}
                    </Button>
                </div>
                <div style={{padding: '10px'}} className="data-table-header-wrapper">
                    <div className="float-left">
                    </div>
                </div>
                <div style={{padding: '10px'}}>
                    <DataTable className="claimListTable" responsive headerColumnGroup={this.renderHeaders()}
                               emptyMessage={"No items found"}
                               scrollable
                               ref={this.dataTableRef}
                               value={this.props.claim.claimActivityList}
                               columnResizeMode="fit"
                               dataKey="id"
                               selection={this.state.selectedItems}
                               onSelectionChange={e => this.setState({selectedItems: e.value})}>
                        <Column selectionMode="multiple" headerStyle={{width: '3em'}}/>
                        <Column field="activityId" />
                        <Column field="start" />
                        <Column field="type" />
                        <Column field="code" />
                        <Column field="quantity" />
                        <Column field="gross" />
                        <Column field="patientShare" />
                        <Column field="net" />
                        <Column field="orderingClinician" />
                        <Column field="performingClinician" />
                        <Column header="Observation" body={(claimActivity) => this.observationTemplate(claimActivity)}/>
                        <Column header="Resubmission" body={(claimActivity) => this.resubmisssionTemplate(claimActivity)}/>
                        <Column header="Submission Version" body={() => this.submissionVersionTemplate()}/>
                        <Column header="Remittance Version" body={(claimActivity) => this.remittanceVersionTemplate(claimActivity)}/>
                    </DataTable>
                </div>
                {this.renderXmlPreviewModal()}
                <ClaimCheckerResultDialog header={this.state.claimCheckDialogHeader} visible={this.state.claimCheckDialogVisible}
                                          result={this.state.claimCheckResult}
                                          onClose={() => this.setState({claimCheckDialogVisible: false})}/>
            </>
        )
    }
}
